import { Card, CardContent } from "@material-ui/core";
import React from "react";
import "./DefaultCardStyle.scss";

const DefaultCard = React.forwardRef((props, ref) => {

    const { content, style } = props

    return (
        <>
            <Card style={style} className="content">
                <CardContent >
                    {content}
                </CardContent>
            </Card>
        </>
    )
})

export default DefaultCard;